export default function logout(history){
    localStorage.removeItem("authenticated");
    localStorage.removeItem("user");
    localStorage.removeItem("salespartner");
    history.push('/login')
}